var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFolderOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6.9375H12.8125V5.1625C12.8125 4.88594 12.5891 4.6625 12.3125 4.6625H7.39062L5.55781 2.90937C5.53449 2.88754 5.50382 2.87527 5.47188 2.875H1.5C1.22344 2.875 1 3.09844 1 3.375V12.625C1 12.9016 1.22344 13.125 1.5 13.125H12.4062C12.6094 13.125 12.7937 13.0016 12.8703 12.8125L14.9641 7.625C14.9875 7.56563 15 7.50156 15 7.4375C15 7.16094 14.7766 6.9375 14.5 6.9375ZM2.125 4H5.07031L6.93906 5.7875H11.6875V6.9375H3.71875C3.51562 6.9375 3.33125 7.06094 3.25469 7.25L2.125 10.05V4ZM12.0516 12H2.48438L4.09844 8H13.6672L12.0516 12Z",
    fill: "#262626"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.627616ba3d85492421ed8298336fc657.svg";
export { ForwardRef as ReactComponent };